// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2klyM","label":"Section_label__3VBgA","contentWrap":"Section_contentWrap__3nkXP","footer":"Section_footer__-f7mb","footerInner":"Section_footerInner__2F-vR"};